import React from 'react';
import { TColorRole, colorMap } from '../../../types/types';

interface ICheckerProps {
    color?: TColorRole;
}

export const Checker: React.FC<ICheckerProps> = ({ color = 'success' }) => {
    const hexColor = colorMap[color] || colorMap['success'];
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path className="path" d="M4.00023 17.4999L11.6897 24.7806L27.7674 8.17467" stroke={`${hexColor}`} strokeWidth="4" />
        </svg>
    );
};
